import { render, staticRenderFns } from "./select-service-project.vue?vue&type=template&id=374b2d3b&scoped=true&"
import script from "./select-service-project.vue?vue&type=script&lang=js&"
export * from "./select-service-project.vue?vue&type=script&lang=js&"
import style0 from "./select-service-project.vue?vue&type=style&index=0&id=374b2d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374b2d3b",
  null
  
)

export default component.exports